import { render } from "./OtpComponent.vue?vue&type=template&id=cc729c32"
import script from "./OtpComponent.vue?vue&type=script&lang=js"
export * from "./OtpComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Otp/OtpComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cc729c32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cc729c32', __exports__)) {
    api.reload('cc729c32', __exports__)
  }
  
  module.hot.accept("./OtpComponent.vue?vue&type=template&id=cc729c32", () => {
    api.rerender('cc729c32', render)
  })

}


export default __exports__